<template>
    <a-modal v-model="visible" title="电子签章授权" :footer="null" :width="560" :closable="false" :keyboard="false" :maskClosable="false">
        <div>请授权平台为您开通电子签章服务，以便您在平台上使用数字证书签署电子合同。</div>
        <div class="spaceLeft">
            <span>授权码：</span>
            <div class="input-box">
                <a-input v-model="code" style="width:300px"/>
                <button-load @clickHandle="onFetchCode" type="primary" :disabled="countDisabled" class="input-btn" size="small">
                    <template slot="lable">
                        <span v-show="counter>0">{{counter}}</span>{{countDisabled?"重新获取":"获取授权码"}}
                    </template>
                </button-load>
            </div>
            <button-load @clickHandle="okModal"  type="primary" :disabled="code.length==0" style="margin-left:8px" lable="确定"></button-load>
        </div>
        <div style="margin-left:60px;">短信验证码将发送至：{{$store.getters["home/getUserObj"].signMobile | phoneFilter}}</div>
        <div class="sign-margin">
            <a class="sign-margin" target="_blank" href="https://www.anxinsign.com/Web/about/serviceAgreement">安心签平台服务协议</a><br/>
            <a class="sign-margin" target="_blank" href="https://www.anxinsign.com/Web/about/secretDeclare">安心签平台隐私声明</a><br/>
            <a class="sign-margin" target="_blank" href="https://www.anxinsign.com/Web/about/serviceAgreement">CFCA数字证书服务协议</a>
        </div>
    </a-modal>
</template>
<script>
/**
 * 电子签章弹窗
 */
import {AccountAuthorizeCodeAPI,AccountConfirmCodeAPI} from "@/api/eleSign.js"
export default {
    name:"eleSign",
    data() {
        return {
            visible:false,
            code:"",
            countDisabled:false,
            counter:0,
        };
    },
    computed: {},
    methods: {
        open(){
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
        okModal(btn){
            const param = {
                oriCode: this.code
            }
            AccountConfirmCodeAPI(param).then(res => {
                if(res.code)
                this.$message.success("操作成功");
                this.$emit("ok");
                // this.MENUAPI.goToOneTab({
                //     path:"inquiry/legaltexts"
                // })
                this.close();
            }).catch(err => {
                btn.closeLoad();
            })
        },
        countTimmer(init){
            if(init) {
                this.countDisabled = true;
                this.counter = 60;
            }
            if(this.counter > 0){
                setTimeout(() => {
                    this.counter --;
                    this.countTimmer();
                },1000)
            }else{
                this.countDisabled = false;
            }
        },
        // 发送验证码
        onFetchCode(btn) {
            AccountAuthorizeCodeAPI().then(res => {
                this.countTimmer(true);
                this.$message.success("验证码发送成功");
                btn.closeLoad();
            }).catch(err => {
                btn.closeLoad();
                console.log(err);
            });
        },
    },
    created() {
    },
    mounted() {}
}
</script>
<style scoped>
.input-box{
    line-height: 40px;
    position: relative;
}
.input-btn{
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 12px;
}
.spaceLeft{
    margin-top:24px;
}
.sign-margin{
    display: inline-block;
    margin-top:12px;
}
</style>


// WEBPACK FOOTER //
// src/components/sign/eleSign.vue